export default __webpack_public_path__ + "static/media/190629_190332_IMG_3534.9515fa5c.jpg";